<div class="linked-services-container">

    <!-- Search Bar -->
    <div class="search-container">
        <div class="search-row">
            <div class="search-bar">
                <hub-input
                    [(ngModel)]="searchTerm"
                    [placeholder]="'bikeshop.modal.update_job_card.job_card.search_linked_services' | translate"
                    [allowClear]="true"
                    [iconColor]="'#888888'"
                    [icon]="'search'"
                    (ngModelChange)="onSearchChange()"
                    (cleared)="clearSearch()">
                </hub-input>
            </div>
            <div class="sort-container">
                <div class="sort-label">{{ 'bikeshop.modal.update_job_card.job_card.order_by' | translate }}</div>
                <hub-button *ngFor="let option of sortOptions" [size]="'sm'"
                    [style]="sortField === option.field ? 'secondary' : 'outline'"
                    [text]="option.label | translate"
                    [icon]="sortField === option.field ? (sortAsc ? 'chevron-up' : 'chevron-down') : ''"
                    [iconPosition]="'right'"
                    (buttonClick)="sortBy(option.field)">
                </hub-button>
            </div>
        </div>
        <div class="search-results-info" *ngIf="searchTerm && searchTerm.trim() !== ''">
            <span>
                {{ 'bikeshop.modal.update_job_card.job_card.search_results' | translate : {count: filteredActiveJobs.length + filteredClosedJobs.length, total: linkedServices.length} }}
            </span>
        </div>
    </div>

    <ng-template #linkedJobs let-jobs="jobs">
        <div class="jobcard" *ngFor="let job of jobs" (click)="selectJob(job)">
            <div class="jobcard-header">
                <div class="job-number" [ngClass]="{'can-favourite': hasMultipleCustomers && !isFavourite(job) && !hasExternalKey(job), 'favourite-blocked': hasMultipleCustomers && hasExternalKey(job)}"
                    (click)="hasMultipleCustomers && toggleFavourite(job, $event)">#{{job.jobCardID}}
                    <span class="favourite" *ngIf="hasMultipleCustomers" [ngClass]="{'selected': isFavourite(job)}">
                        <i class="fa" [ngClass]="isFavourite(job) ? 'fa-star' : 'fa-star-o'"></i>
                    </span>
                    <span class="active" *ngIf="job.statusID < 40">{{'bikeshop.quicklaunch.active' | translate}}</span>
                    <span class="closed" *ngIf="job.statusID >= 40 && job.statusID !== 100">{{'general.closed' |
                        translate}}</span>
                </div>
                <div class="jobcard-actions">
                    <hub-button [size]="'lg'" [style]="'outline'" [icon]="'message-circle-chat'"
                        pTooltip="{{'bikeshop.modal.update_job_card.job_card.messages' | translate}}"
                        pTooltipPosition="bottom"
                        (buttonClick)="openMessaging(job, $event)">
                    </hub-button>
                    <hub-button [size]="'lg'" [style]="'outline'" [icon]="'link-slash-alt'" 
                        [disabled]="isUnlinkDisabled(job)"
                        pTooltip="{{'bikeshop.modal.update_job_card.job_card.unlink_jobcard' | translate}}"
                        pTooltipPosition="bottom"
                        (buttonClick)="unlinkJob(job, $event)">
                    </hub-button>
                </div>
            </div>
            <div class="jobcard-content">
                <div class="row margin-bottom-16">
                    <div class="col-lg-12">
                        <div class="line-header">{{'general.headers.customer' | translate}}</div>
                        <div class="line-value">{{job.customer}}</div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="line-header">{{'bikeshop.modal.update_job_card.job_card.item' | translate}}
                        </div>
                        <div class="line-value">{{job.manufacturer}} {{job.model}}</div>
                    </div>
                    <div class="col-lg-6">
                        <div class="line-header">{{'bikeshop.modal.add_edit_user.technician' | translate}}
                        </div>
                        <div class="line-value">{{job.technician}}</div>
                    </div>
                </div>

                <div class="row margin-top-16">
                    <div class="col-lg-6">
                        <div class="line-header">{{'bikeshop.modal.update_job_card.job_card.scheduled_for' |
                            translate}}
                        </div>
                        <div class="line-value">{{job.scheduledDate}}</div>
                    </div>
                    <div class="col-lg-6" *ngIf="job.dateRequiredBy">
                        <div class="line-header">{{'bikeshop.modal.shedule_service.required_by' | translate}}
                        </div>
                        <div class="line-value">{{job.dateRequiredBy}}</div>
                    </div>
                </div>

                <div class="row margin-top-16">
                    <div class="col-lg-6">
                        <div class="line-header">{{'bikeshop.modal.update_job_card.job_card.job_status' |
                            translate}}
                        </div>
                        <div class="job-status {{getStatusBackgroundStyle(job)}}">{{getStatusLabel(job)}}</div>
                    </div>
                    <div class="col-lg-6">
                        <div class="line-header">{{'bikeshop.modal.update_job_card.job_card.payment_status' |
                            translate}}
                        </div>
                        <div class="payment-status"
                            [ngClass]="{'paid': job.paid, 'partially-paid': !job.paid && job.amountPaid, 'not-paid': !job.paid && !job.amountPaid}">
                            {{(
                            job.paid ? 'bikeshop.modal.update_job_card.job_card.payment_status_paid' :
                            !job.paid && job.amountPaid ?
                            'bikeshop.modal.update_job_card.job_card.payment_status_partialy_paid' :
                            'bikeshop.modal.update_job_card.job_card.payment_status_not_paid'
                            ) | translate}}</div>
                    </div>
                </div>

                <div class="total">
                    <div>{{ 'bikeshop.modal.update_job_card.quote.total' | translate }}</div>
                    <div><span>{{job.duration.toFixed(1)}}{{(
                            job.duration.toFixed(0) === 1
                            ? 'general.hr' : 'general.hrs' ) | translate }}</span> |
                        {{ job.invoiceTotal | currency : currencySymbol }}</div>
                </div>

            </div>
        </div>
    </ng-template>

    <div class="linked-services" [ngClass]="{'disabled': filteredActiveJobs.length === 0}">
        <div class="linked-services-header">
            <div>{{ 'bikeshop.modal.update_job_card.job_card.active_jobs' | translate }} 
                <span>{{ filteredActiveJobs.length }}</span>
                <span *ngIf="searchTerm && searchTerm.trim() !== '' && filteredActiveJobs.length !== activeJobs.length">
                    {{ 'bikeshop.rentals.service_indicator_status_report.of' | translate }} {{ activeJobs.length }}
                </span>
            </div>
            <div><hub-button [size]="'lg'" [style]="'outline'" [icon]="activeJobsOpen ? 'chevron-up' : 'chevron-down'"
                    [disabled]="filteredActiveJobs.length === 0" (buttonClick)="toggleSection('ACTIVE_JOBS', $event)">
                </hub-button></div>
        </div>
        <div class="linked-services-content" *ngIf="activeJobsOpen">
            <ng-container *ngTemplateOutlet="linkedJobs; context: { jobs: filteredActiveJobs }"></ng-container>
        </div>
    </div>

    <div class="linked-services" [ngClass]="{'disabled': filteredClosedJobs.length === 0}">
        <div class="linked-services-header">
            <div>{{ 'bikeshop.modal.update_job_card.job_card.completed_jobs' | translate }} 
                <span>{{ filteredClosedJobs.length }}</span>
                <span *ngIf="searchTerm && searchTerm.trim() !== '' && filteredClosedJobs.length !== closedJobs.length">
                    {{ 'bikeshop.rentals.service_indicator_status_report.of' | translate }} {{ closedJobs.length }}
                </span>
            </div>
            <div><hub-button [size]="'lg'" [style]="'outline'" [icon]="closedJobsOpen ? 'chevron-up' : 'chevron-down'"
                    [disabled]="filteredClosedJobs.length === 0" (buttonClick)="toggleSection('CLOSED_JOBS', $event)">
                </hub-button></div>
        </div>
        <div class="linked-services-content" *ngIf="closedJobsOpen">
            <ng-container *ngTemplateOutlet="linkedJobs; context: { jobs: filteredClosedJobs }"></ng-container>
        </div>
    </div>

    <div class="linked-services-total">
        <div>{{ 'bikeshop.modal.update_job_card.job_card.total_linked_job_cards' | translate }}</div>
        <div><span>{{totalDuration.toFixed(1)}}{{ (totalDuration === 1 ? 'general.hr' : 'general.hrs') | translate }}</span> |
            {{ totalAmount | currency : currencySymbol }}</div>
    </div>

</div>
<p-toast key="all-linked-services-toast" position="bottom-center"></p-toast>

<p-sidebar #messagingSidebar [(visible)]="showMessaging" position="right" [dismissible]="true" [closeOnEscape]="true"
    styleClass="custom-sidebar" [appendTo]="'body'" [showCloseIcon]="false"
    [style]="{width:'36em', background: 'white'}" (onHide)="messagingSidebar.destroyModal(); closeMessaging()">
    <app-workshop-jobcard-messaging-attachments *ngIf="showMessaging && messagingJobcard"
        [jobcard]="messagingJobcard" [messagesOnly]="true" (close)="closeMessaging()">
    </app-workshop-jobcard-messaging-attachments>
</p-sidebar>